const md5 = require('md5')
const sha256 = require('js-sha256')

export function createUniqueEventId(pattern) {
  const currentTimestamp = Math.floor(new Date() / 1000)
  const randomToken = Math.floor(Math.random() * 10000)
  return `${pattern}-${currentTimestamp}-${randomToken}`
}

export function getEcommerceEventByAction(action) {
  let event
  switch (action) {
    case 'add':
    case 'update':
      event = 'add_to_cart'
      break
    case 'remove':
    case 'delete':
      event = 'remove_from_cart'
      break

    default:
      break
  }
  return event
}

export function getUniqueTrackingName({ offer }) {
  const price = parseFloat(offer.price).toFixed(2)
  if (offer.num_of_issues || offer.numOfIssues) {
    // By default we will use the trackingName ex '13 issues for £20.00' for a DD offer
    // console.log(`getUniqueTrackingName offer.paymentType=${offer.paymentType} name=${offer.numOfIssues} issues for £${offer.price}`)
    return `${offer.num_of_issues || offer.numOfIssues} issues for £${price}` // MONGODB NUM_OF_ISSUE
  } else {
    // Gift Card and E-Gift Card ONLY
    if (offer.id === 'GIFT' || offer.id === 'EGFT') {
      return `£${price}`
    }
    // Fix for Search pages otherwise we will have the numOfIssues equal to undefined
    // console.log(`getUniqueTrackingName offer.paymentType=${offer.paymentType} NO ISSUES FOUND name=${offer.name}`)
    return `${offer.name}`
  }
}

function getGA4TrackingName({ magazine, offer }) {
  // console.log('getGA4TrackingName magazine=', magazine)
  // console.log('getGA4TrackingName offer=', offer)

  const price = parseFloat(offer.price).toFixed(2)
  const title = magazine.title
  const subs = getUniqueTrackingName({ offer })

  // Gift Card and E-Gift Card ONLY
  if (magazine.id === 'GIFT') {
    // console.log(`getGA4TrackingName=Gift Card - £${price}`)
    return `Gift Card - £${price}`
  }
  if (magazine.id === 'EGFT') {
    // console.log(`getGA4TrackingName=E-Gift Card - £${price}`)
    return `E-Gift Card - £${price}`
  }
  if (magazine.id === 'PLUS') {
    const label = offer?.offer?.label || offer?.label || ''
    // console.log(`getGA4TrackingName=Pocketmags Plus+ - ${label}`)
    return `Pocketmags Plus+ - ${label}`
  }
  if (magazine.title && magazine.title.toLowerCase().includes('bookazine')) {
    // console.log(`getGA4TrackingName=${title} - £${price}`)
    return `${title} - £${price}`
  }

  // console.log(`getGA4TrackingName=${title} - ${subs}`)
  return `${title} - ${subs}`
}

export function getGA4EcommerceNullPayload() {
  console.log(`Trigger { ecommerce: null }`)
  return { ecommerce: null }
}

export function getGA4SelectPromotionPayload({ banner, locationId }) {
  let creativeSlot = banner.key
  if (parseInt(banner.key)) {
    creativeSlot = banner.key + 1 + ''
  }

  console.dir({
    event: 'select_promotion',
    ecommerce: {
      items: [
        {
          item_id: banner.id,
          item_name: banner.alt, // Ex. 'Stan and Friends Tee'
          promotion_id: banner.id, // Ex. 'sc2021'
          promotion_name: banner.alt, // Ex. 'summer_campaign_2021'
          // creative_name: undefined, // Ex. 'family_in_bathing_suits_1',
          creative_slot: creativeSlot, // Ex. 'featured_items',
          location_id: locationId // Ex. homepage_hero_banner, category_hero_banner, thehub_hero_banner, sitewide_banner
        }
      ]
    }
  })
  return {
    event: 'select_promotion',
    ecommerce: {
      items: [
        {
          item_id: banner.id,
          item_name: banner.alt, // Ex. 'Stan and Friends Tee'
          promotion_id: banner.id, // Ex. 'sc2021'
          promotion_name: banner.alt, // Ex. 'summer_campaign_2021'
          // creative_name: undefined, // Ex. 'family_in_bathing_suits_1',
          creative_slot: creativeSlot, // Ex. 'featured_items',
          location_id: locationId // Ex. homepage_hero_banner, category_hero_banner, thehub_hero_banner, sitewide_banner
        }
      ]
    }
  }
}

export function getGA4EcommerceBasketActionPayload({ action, item, eventId, email }) {
  if (action === undefined || item === undefined) {
    return
  }

  // console.log('getGA4EcommerceBasketActionPayload ACTION=', action)
  // console.log('getGA4EcommerceBasketActionPayload ITEM=', item)
  // console.log('getGA4EcommerceBasketActionPayload EVENT_ID=', eventId)
  // console.log('getGA4EcommerceBasketActionPayload email=', email)

  const name = getGA4TrackingName({
    magazine: item,
    offer: item.offer
  })

  const payload = {
    event: getEcommerceEventByAction(action),
    eventID: eventId,
    ecommerce: {
      items: [
        {
          // GA4 Syntax attributes
          item_name: name,
          item_id: item.offer.sku,
          price: Number(item.offer.cpa).toFixed(2),
          currency: 'GBP',
          discount: '0',
          item_brand: item.title || '',
          item_category: item?.category || '',
          item_category2: item?.category_2 || '',
          quantity: action === 'delete' ? Number(item.offer.qty) : Number(1),

          // Custom attributes
          payment_type: item.offer.paymentType || item.offer.payment_type,
          product_issues: item.offer.numOfIssues || item.offer.num_of_issues || 0,
          product_price: item.offer.price,
          product_rrp: item.offer.rrp,
          product_type: item.offer.product_type || item.offer.type || 'PRINT'
        }
      ]
    }
  }

  if (email && email !== '') {
    payload.email = email
    payload.emailMD5 = md5(email)
    payload.emailSHA256 = sha256(email)
  }

  // console.log('getGA4EcommerceBasketActionPayload payload=', payload)

  return payload
}

export function getGA4ViewItemPayload({ magazine, offers, rawItems }) {
  let items = []

  console.log('getGA4ViewItemPayload MAGAZINE=', magazine)
  console.log('getGA4ViewItemPayload OFFERS=', offers)
  console.log('getGA4ViewItemPayload RAW_ITEMS=', rawItems)

  if (rawItems) {
    // Used for E-Gift Cards, Gift Cards, PKMG plus
    items = [...rawItems]
  } else {
    offers &&
      Object.keys(offers).forEach(type => {
        // console.log('TYPE=', type)
        offers[type].forEach(offer => {
          // console.log('OFFER=', offer)

          const name = getGA4TrackingName({
            magazine,
            offer
          })

          items.push({
            // GA4 Syntax attributes
            item_name: name,
            item_id: offer.sku,
            price: offer.cpa,
            currency: 'GBP',
            discount: '0',
            item_brand: magazine.title || offer.title,
            item_category: magazine.category || offer.category,
            item_category2: magazine.subCategory || offer.subCategory,

            // Custom attributes
            payment_type: offer.paymentType,
            product_issues: offer.numOfIssues,
            product_price: offer.price,
            product_rrp: offer.rrp,
            product_type: type
          })
        })
      })
  }

  const payload = {
    event: 'view_item',
    ecommerce: {
      items
    }
  }

  // console.log('getGA4ViewItemPayload payload=', payload)

  return payload
}

export function getGTMCoreVitalsPayload({ name, delta, id, entries, value }) {
  console.log('getGTMCoreVitalsPayload=', { name, delta, id, entries, value })
  return {
    event: 'WebVitals',
    webVitals: {
      eventCategory: 'Web Vitals',
      eventAction: name,
      // The `id` value will be unique to the current page load. When sending
      // multiple values from the same page (e.g. for CLS), Google Analytics can
      // compute a total by grouping on this ID (note: requires `eventLabel` to
      // be a dimension in your report).
      eventLabel: id,
      // Google Analytics metrics must be integers, so the value is rounded.
      // For CLS the value is first multiplied by 1000 for greater precision
      // (note: increase the multiplier for greater precision if needed).
      eventValue: Math.round(name === 'CLS' ? delta * 1000 : delta)
      // Use a non-interaction event to avoid affecting bounce rate.
      // nonInteraction: true,
      // Use `sendBeacon()` if the browser supports it.
      // transport: 'beacon'

      // OPTIONAL: any additional params or debug info here.
      // See: https://web.dev/debug-web-vitals-in-the-field/
      // dimension1: '...',
      // dimension2: '...',
      // ...
    }
  }
}

export function getGA4ViewCartPayload({ basket }) {
  const items = []
  const eventID = createUniqueEventId('PageView')
  console.info(`getGA4ViewCartPayload eventID=${eventID} basket=`, basket)
  let totalCPA = 0
  basket?.items &&
    basket?.items?.length >= 1 &&
    basket.items.forEach(item => {
      console.info('getGA4ViewCartPayload item=', item)
      // GA4 Syntax attributes
      let data = {
        item_name: (item?.offer && `${item?.offer?.title || item.title || ''} - ${item?.offer.num_of_issues} issues for £${item?.offer.num_of_issues}`) || '',
        item_id: item.offer.sku,
        price: item.offer.cpa,
        currency: 'GBP',
        discount: 0,
        quantity: 1,
        item_brand: item?.offer?.title || item.title || '',
        item_category: item?.category || '',
        item_category2: item?.category_2 || '',

        // Custom attributes
        product_price: item.offer.price + '',
        product_rrp: item.offer.rrp + '',
        product_issues: item.offer.num_of_issues,
        product_type: getProductTypeForViewCard({ item }),
        payment_type: item.offer.payment_type
      }

      if (item.type === 'GIFTCARD') {
        data = {
          item_name: `Gift Card - £${item.offer.price}`,
          item_id: 'gift-card',
          price: item.offer.cpa,
          currency: 'GBP',
          discount: 0,
          quantity: 1,
          item_brand: 'Gift Card',
          item_category: 'Gift Cards & E-Codes',
          item_category2: '',

          // Custom attributes
          product_price: item.offer.price + '',
          product_rrp: '0.00',
          product_issues: 0,
          product_type: 'GIFTCARD',
          payment_type: 'CC'
        }
      } else if (item.type === 'EGIFTCARD') {
        data = {
          item_name: `E-Gift Card - £${item.offer.price}`,
          item_id: 'e-giftcard',
          price: item.offer.cpa,
          currency: 'GBP',
          discount: 0,
          quantity: 1,
          item_brand: 'E-Gift Card',
          item_category: 'Gift Cards & E-Codes',
          item_category2: '',

          // Custom attributes
          product_price: item.offer.price + '',
          product_rrp: '0.00',
          product_issues: 0,
          product_type: 'EGIFTCARD',
          payment_type: 'CC'
        }
      } else if (item.type === 'POCKETMAGSPLUS') {
        data = {
          item_name: `Pocketmags Plus+ - ${item.custom_fields.offer.label}`,
          item_id: 'pocketmagsplus',
          price: item.offer.cpa,
          currency: 'GBP',
          discount: 0,
          quantity: 1,
          item_brand: 'Pocketmags Plus+',
          item_category: 'Gift Cards & E-Codes',
          item_category2: '',

          // Custom attributes
          product_price: item.offer.price + '',
          product_rrp: '0.00',
          product_issues: item.offer.num_of_issues,
          product_type: 'POCKETMAGSPLUS',
          payment_type: 'CC'
        }
      }

      totalCPA += item.offer.cpa

      items.push(data)
    })

  const payload = {
    event: 'view_cart',
    ecommerce: {
      currency: 'GBP',
      value: totalCPA,
      coupon: basket?.disount?.code || '',
      shipping_tier: 'Free',
      items
    },
    eventID
  }

  console.log('getGA4ViewCartPayload payload=', payload)

  return payload
}

function getProductTypeForViewCard({ item }) {
  let type = 'PRINT'
  if (item.offer.offer_type === '1 ISSUE') {
    type = 'SINGLE_ISSUES'
  } else if (item?.offer?.zone || item.offer.zone === 'UK') {
    type = 'PRINT'
  } else {
    type = 'INTERNATIONAL'
  }

  if (item.type === 'EGIFTCARD') {
    type = 'EGIFTCARD'
  }

  if (item.type === 'GIFTCARD') {
    type = 'GIFTCARD'
  }

  if (item.type === 'MEMBERSHIP') {
    type = 'MEMBERSHIP'
  }

  if (item.type === 'POCKETMAGSPLUS') {
    type = 'DIGITAL'
  }

  return type
}
